/**
 * Represents the processing flags for a product (NV03 - VAVE).
 * Each flag is stored as a single character.
 */
export enum ProductProcessingFlags {
  /** ER AUTO-OPPDATERT FRA LEVERANDØR. */
  'A' = 'A',

  /** IKKE AUTOMATISK OPPDATERING AV SVS */
  'S' = 'S',

  /** IKKE AUTOMATISK OPPDATERING AV UTPRIS */
  'U' = 'U',

  /** KONSERNOPPDATERING I VSAMUKE3 */
  'K' = 'K',

  /** IKKE AUTOMATISK OPP. AV LEV-PRIS,-RAB,-NR. */
  'L' = 'L',

  /** OPPDATERT VIA DISKETTE LEVERT AD */
  'D' = 'D',

  /** ØNSKER IKKE AUTO-OPPDATERING. */
  'X' = 'X',
}
